import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_detailNoticeList} from "function/FnBodySetting"
import NoticeListView from "../main/body/layer/NoticeListView";
import NoticeDetailListView from "../main/body/layer/NoticeDetailListView";
import {notice_list} from "http/SettingConn";

@observer
class SettingNoticeView extends Component {

    componentWillUnmount() {
        const { rootStore } = this.props;
        //초기화
        notice_list(rootStore, "1"); //공지사항목록
    }

    render() {
        const { rootStore } = this.props;
        return(
            <>
                <div className="article_setting">
                    <NoticeListView rootStore={rootStore} />
                    <NoticeDetailListView rootStore={rootStore} />
                </div>
            </>
        )
    }
}

export default SettingNoticeView;